export default "__VITE_ASSET__DJLfXs5___"